import { Body, Container, Heading, useToast } from '@hover/blueprint';
import { iBell, iCheck } from '@hover/icons';
import React, { useState } from 'react';

import comingSoon from 'src/assets/img/homeownerApp/modules/linkOuts/comingSoon.png';
import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { Button } from 'src/shared/components';
import { FeatureFlag } from 'src/shared/constants';
import {
  TranslationNamespace,
  useTranslate,
  useTreatmentWithConfig,
} from 'src/shared/hooks';

import { SplitCard } from '../../Card';

export const ComingSoon = ({ projectId }: { projectId: string }) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const toast = useToast();
  const [notifyMe, setNotifyMe] = useState(false);

  const { treatment, config } =
    useTreatmentWithConfig<FeatureFlag.ComingSoonLinkouts>(
      FeatureFlag.Designer.COMING_SOON,
    );

  const { trackingData, user } = useHomeownerAppContext();

  const handleNotifyMeClick = () => {
    setNotifyMe(true);
    toast({
      position: 'top-right',
      duration: null,
      description: t('toast.comingSoon'),
      props: {
        colorScheme: 'dark',
        borderRadius: '400',
      },
    });
  };

  if (treatment !== 'on' || !user?.isHomeowner || !config?.comingSoon?.title)
    return null;

  return (
    <Container mt={600} padding={0} width="100%">
      <SplitCard
        backgroundImage={config.comingSoon.heroImage || comingSoon}
        onResponsiveChangeOrientation
      >
        <Body isSemiBold size={400}>
          {config.comingSoon.subtitle}
        </Body>
        <Heading as="p" size={500}>
          {config.comingSoon.title}
        </Heading>
        <Body size={400}>{config.comingSoon.description}</Body>
        <Button
          iconAfter={notifyMe ? iCheck : iBell}
          includeTrackingImpression
          mt={400}
          onClick={notifyMe ? () => {} : handleNotifyMeClick}
          optionalTrackingProperties={{
            track_id: 'measurements-get-notified',
            button_location: 'Measurements tile',
            primary_cta: true,
            project_id: Number(projectId),
            ...trackingData,
          }}
          variant={notifyMe ? 'tertiary' : 'primary'}
          width="100%"
        >
          {config.comingSoon.buttonText}
        </Button>
      </SplitCard>
    </Container>
  );
};
